var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.submitted)?_c('div',[_c('AdminLogovanje',{on:{"updateNaslovna":_vm.submit}})],1):_c('div',[_c('h3',[_vm._v("Детаљи корисника")]),_c('MojProfil',{on:{"updateRegistracija":_vm.submit}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }